import { useCallback, useMemo, useState } from "react";
import { ScheduleService } from 'services/ScheduleService';
import { ShiftProfileGroup } from 'repository/schedule/@types/ShiftProfileGroup';
import { GridInputRowSelectionModel, GridColDef } from '@mui/x-data-grid-pro';

const scheduleService = new ScheduleService();

export const useShiftProfileGroupsData = () => {
    const [rows, setRows] = useState<ShiftProfileGroup[]>([]);
    const [loading, setLoading] = useState(false);
    const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
    const [selectedGroup, setSelectedGroup] = useState<GridInputRowSelectionModel | undefined>([]);
    const [selected, setSelected] = useState<any>([]);

    const loadData = useCallback(async () => {
        setLoading(true);
        try {
            const data = await scheduleService.shift_profile_group.getAll();
            setRows(data);
        } catch (error) {
            console.error("Error loading shift profile groups:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    const columns: GridColDef[] = useMemo(() => [
        { field: 'shift_profile_group_name', headerName: 'Nombre de Perfil', flex: 1 },
        { field: 'shift_profile_group_description', headerName: 'Descripción', flex: 2 },
    ], []);

    const cleanSelected = useCallback(() => {
        setSelected([]);
        setSelectedGroup([]);
    }, []);

    return {
        rows,
        loading,
        loadData,
        selectedGroup,
        setSelectedGroup,
        contextMenu,
        setContextMenu,
        selected,
        setSelected,
        columns,
        cleanSelected,
    };
};
